module.exports = __webpack_public_path__ + "static/website-f7c4a9f9a6fabd191439b99c255796a9.png";